import {
  addExpenseApi,
  getAccountFreghtList,
  getChartExpense,
  getChartRecipt,
  getCommonExpenseApi,
  getExpense,
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
} from "_services";
import { getBranchDropdownListData } from "_services/dropdownServices/dropdownService";
import { addClaimPartyInvoiceDetails } from "_services/invoiceBillRaiseServices";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CrossButton,
  CustomSelect,
  LoaderButton,
  SkeletonInput,
} from "components";
import { Images } from "constants";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import SelectLrForInvoiceDetailsModal from "modals/SelectLrForInvoiceDetailsModal";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const ClaimInvoiceDetails = (props) => {

  let { id } = useParams();
  const [selectLrData, setSelectLrData] = useState(false)
  const [showSelectLr, setShowSelectLr] = useState(false);

  const {
    lrDetails,
    tripId,
    isOpen,
    closeModal,
    filterData, callInvoiceDetailsApi,
    transactionList,
    billRaiseDetailsData
  } = props;

  const initiFrom = {
    date: new Date(),
    description: '',
    amount: '',
    expense_category: '',
    account_category: '',
    account_sub_category: '',
    account_id: '',
    lr_id: '',
    company_id: StorageService.getCompanyId(),
    billraise_id: id ? id : '',
    consignor_id: filterData?.consignor_id?.value ? filterData?.consignor_id?.value : '',
  };

  const {
    masterData,
    globTripDetails,
    bankDetails,
    setModalZIndex,
    modalZIndex,
    setBankDetails,
    userSettingPermission,
    allMenu
  } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [claimTypeList, setClaimTypeList] = useState([]);
  const [claimAccount, setClaimAccount] = useState([]);
  const [accountPartyType, setAccountPartyType] = useState("");
  const [accountSupplierType, setAccountSupplierType] = useState("");
  const [expenseList, setExpenseList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [commExpenseList, setCommExpenseList] = useState([]);
  const [accountList2, setAccountList2] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reciptList, setReciptList] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState("");
  const [receiptDetails, setReceiptDetails] = useState("");
  const [isloadingSend, setIsloadingSend] = useState(false);
  const balance = props?.transactionList?.freight_summary?.balance;
  const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
  const [dropdownBranchList, setDropdownBranchList] = useState([]);
  const hasLinkCharofAccountPermission = getAllPermissions("/accounting/chartofaccounts", allMenu, 'link');


  useEffect(() => {
    if (form?.sub_category) {
      getCommonExpense(form?.sub_category);
      handleOnChange("expense_category", "");
    }
  }, [form?.sub_category]);

  const getDropdownDataBranchList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        search: "",
      };
      const res = await getBranchDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.branch_list?.map((el) => {
          return {
            label: el?.branch,
            value: el?._id,
          }
        })
        setDropdownBranchList(data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getMasterFreight();
    getDropdownDataBranchList();
  }, []);

  useEffect(() => {
    if (accountSupplierType) {
      setForm({ ...form, account_id: "" });
    }
  }, [accountSupplierType]);

  useEffect(() => {
    if (accountPartyType) {
      setForm({ ...form, party_account_id: "" });
    }
  }, [accountPartyType]);

  useEffect(() => {
    if (form?.account_sub_category != 10 && form?.account_category) {
      if (form?.account_id == "") {
        setIsCheck(false);
        getAccountListHandler();
      }
    }
  }, [form?.account_sub_category, form?.account_category, form?.account_id]);

  useEffect(() => {
    if (
      form?.party_account_sub_category != 10 &&
      form?.account_category &&
      accountList?.length
    ) {
      getAccountListHandler2();
      if (form?.party_account_id == "") {
      }
    }
  }, [
    form?.party_account_sub_category,
    form?.account_category,
    accountList,
    form?.party_account_id,
  ]);

  useEffect(() => {
    if (props?.accountList?.length > 0) {
      let list = props?.accountList?.map((i) => {
        return {
          ...i,
          label: i?.bank_name ? i?.bank_name : i?.upi_id,
          value: i?._id,
        };
      });
      setBankAccountList(list);
    }
  }, [props?.accountList]);

  useEffect(() => {
    if (bankDetails) {
      handleOnChange("vendor_bank_account", bankDetails?._id);
    }
  }, [bankDetails]);

  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
      if (form?.vendor_account) {
        setForm({ ...form, vendor_account: "" });
      }

    } else {
      setForm({ ...form, vendor_account: bankAccountList[0]?._id });
      setBankDetails(bankAccountList[0])
    }
  }, [isCheck]);

  const getMasterFreight = async () => {
    try {
      const details = masterData?.account_category?.sub_category?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          category_id: masterData?.account_category?.id,
        };
      });

      const detailsAccount = masterData?.account_category?.sub_category
        ?.filter((k) => (k.id !== 2 || k.id !== 3 || k.id !== 14 || k.id !== 15))
        ?.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            category_id: masterData?.account_category?.id,
          };
        });

      const final = details?.reverse();

      const reorderedItems = detailsAccount.filter(
        (item) => item.label !== "Invoice"
      );
      const cashItem = detailsAccount.find((item) => item.label === "Invoice");
      let list = [cashItem];

      if (list.length && details) {
        setForm({
          ...form,
          sub_category: final[0]?.value,
          account_category: list[0]?.category_id,
          account_sub_category: list[0]?.value,
        });

        setClaimTypeList(final);
        setClaimAccount(list);
      }
    } catch { }
  };

  const getCommonExpense = async (expense) => {
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        category_id: expense == 1 ? 5 : 4,
        sub_category_id: expense == 1 ? 4 : 3,
      };
      const res = await getCommonExpenseApi(payload);
      if (res?.responseCode === 200) {
        const details = res?.data?.categories?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setCommExpenseList(details);
        setExpenseDetails(res?.data);
      } else {
      }
    } catch (error) { }
  };

  const getAccountListHandler = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        account_id: "",
      });


      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?._id,
        }));

        setAccountList(details);
        // if (details.length > 0) {
        //   handleOnChange("account_id", details[0].value);
        // }
      } else {
        setAccountLoading(false)
        setAccountList([]);

      }
    } catch (error) {
      setAccountLoading(false)
      setAccountList([]);
    } finally {
      setAccountLoading(false)

    }
  };

  const getAccountListHandler2 = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.party_account_sub_category),
        account_id: "",
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?._id,
        }));
        setAccountList2(details);
        if (details.length > 0) {
          handleOnChange("party_account_id", details[0].value);
          // setForm({ ...form, party_account_id: details[0].value });
        }
      } else {
        setAccountLoading(false);
      }
    } catch (error) {
    } finally {
      setAccountLoading(false);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };

    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        stateObj,
        errorSchema.addClaimInvoiceDetailsSchema
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitClaim = async (approve) => {
    const validationResult = await utils.checkFormError(
      form,
      errorSchema.addClaimInvoiceDetailsSchema
    );
    setFormError(validationResult);
    if (validationResult === true) {
      try {
        let payload = {
          ...form,
          lr_id: selectLrData?._id,
        }
        delete payload.sub_category;
        const res = await addClaimPartyInvoiceDetails(payload);
        if (res?.responseCode === 200) {
          setIsLoadding(false);
          setIsloadingSend(false);
          closeModal();
          callInvoiceDetailsApi();
          setBankDetails("");
        } else {
          setIsLoadding(false);
          setIsloadingSend(false);
        }
      } catch {
        setIsLoadding(false);
        setIsloadingSend(false);
      }
    } else {
      setFormError(validationResult);
      setIsLoadding(false);
      setIsloadingSend(false);
    }
  };

  const continueHnadle = async () => {
    const validationResult = await utils.checkFormError(
      { ...form, balance: balance },
      errorSchema.addClaimSchema
    );

    if (validationResult === true) {
      setForm({ ...form, submitType: 2 });
    } else {
      setFormError(validationResult);
    }
  };

  const validateInput = (value) => {
    const number = parseFloat(value);
    return number <= transactionList?.freight_summary?.freight_summary?.balance;
  };

  const backButton = () => {
    setForm({ ...form, submitType: 1 });
  };

  const handleFileChange = async (e, type) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];

          if (type == "first") {
            fileArray.push(...form?.file, {
              filename: res?.data?.filename,
              path: res?.data?.path,
            });
            handleOnChange("file", fileArray);
          } else {
            fileArray.push(...form?.party_file, {
              filename: res?.data?.filename,
              path: res?.data?.path,
            });
            handleOnChange("party_file", fileArray);
          }

          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const partyDocumentRemove = (index) => {
    const newFromIput = [...form?.party_file];

    newFromIput.splice(index, 1);

    setForm({ ...form, party_file: newFromIput });
  };

  const isExpense = form?.sub_category == 2;
  const categoryLabel = isExpense ? "Category" : "Category";
  const categoryPlace = isExpense
    ? "Select Category"
    : " Select Category";
  const categoryOptions = commExpenseList || [{ label: "", value: "" }];
  const selectedCategory = commExpenseList?.find(
    (i) => i.value === form?.expense_category
  );

  const selectedPartCategory = commExpenseList?.find(
    (i) => i.value === form?.party_expense_category
  );

  const totalbalance = props?.transactionList?.freight_summary?.balance || 0;
  const amount = form?.amount || 0;
  const result = balance - amount;

  const callBackApi = (data) => {
    getCommonExpense(form?.sub_category);
    handleOnChange("expense_category", data?.category?._id)
  };

  const addExpenseHandle = (data) => {
    setIsOpenFuelModal(true);
  };

  let openZoneModal = {
    isOpen: isOpenFuelModal,
    closeModal: (e) => setIsOpenFuelModal(false),
    // nextModal: (e) => submitUpdateData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
    submitTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
    footerPart: true,
    label: form?.sub_category == 1 ? 'Expenses Name' : 'Receipt Name',
    placeholder: form?.sub_category == 1 ? 'Enter Expenses Name' : 'Enter Receipt Name',
    ApiPoint: addExpenseApi,
    callBackApi: callBackApi,
    payloadData: {
      category_id: form?.sub_category == 1 == 1 ? 5 : 4,
      sub_category_id: form?.sub_category == 1 == 1 ? 4 : 3,
    },
    titleName: "Trip"
  }

  const getSelectedLrData = async (data) => {
    setSelectLrData(data);
    handleOnChange("lr_id", data?._id);
    setShowSelectLr(false);
  }

  let selectLrModalProps = {
    isOpen: showSelectLr,
    closeModal: (e) => setShowSelectLr(false),
    onSubmit: (e) => setShowSelectLr(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: " _dashCommon_Modal _xxlModal",
    modalTitle: "Select LR",
    submitTitle: "null",
    filterData: filterData,
    getSelectedLrData: (e) => getSelectedLrData(e),
    paramId: id,
    branchList: dropdownBranchList,
    // indexofTable: indexofTable,
    // listOfLr: listOfLr,
    // callbackSelectLr: callbackSelectLr,
    // selectedLr: selectedLr,
    // consignorList: consignorList,
    // branchList: branchList,
    // setSelectParty: setSelectParty,
  };

  return (
    <div>
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""
          }`}
        tabIndex={-1}
        style={{
          visibility: isOpen ? "visible" : "hidden",
          display: modalZIndex ? "none" : "",
        }}
      >
        <div className="offcanvas-header headWith_back">
          <h5 className="offcanvas-title">
            Pay Party
          </h5>
          <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal} >
            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
              <path
                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                fill="black"
              />
            </svg>
          </CrossButton>
        </div>

        <>
          <div className="offcanvas-body">
            <div className="_lrCl_offCavBody">

              {selectLrData?.consignor_name ? (
                <div className="_lrl_otrBx selectedBxs">
                  <div className="_lr_cnpCode">
                    <h4 className="_lrl_cnp">
                      {selectLrData?.consignor_name}
                    </h4>
                    <h4 className="_lrl_code">
                      # {selectLrData?.lr_number}
                    </h4>
                  </div>

                  <div className="_lrlRout_ls mt-3">
                    <div className="_lrHead_fsx">
                      <h3>{selectLrData?.from_location}</h3>
                      <p>
                        {utils.formatDateMonth(selectLrData?.invoice_date)}
                      </p>
                    </div>

                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="136"
                        height="29"
                        viewBox="0 0 136 29"
                        fill="none"
                      >
                        <path d="M0 15L51 15" stroke="#DFE8FF" />
                        <path d="M85 15L136 15" stroke="#DFE8FF" />
                        <circle
                          cx="67.5"
                          cy="14.5"
                          r="14.5"
                          fill="#DFE8FF"
                        />
                        <path
                          d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z"
                          fill="#1450EC"
                        />
                      </svg>
                    </div>

                    <div className="_lrHead_fsx _lrs_rSide">
                      <h3>{selectLrData?.to_location}</h3>
                    </div>
                  </div>

                  <div className="_lr_cnpCode">
                    <h4 className="_lrl_code">
                      INV- {selectLrData?.invoice_number}
                    </h4>

                    <p className="_lrl_stats">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="11"
                          viewBox="0 0 12 11"
                          fill="none"
                        >
                          <ellipse
                            cx="5.54354"
                            cy="5.5"
                            rx="5.54354"
                            ry="5.5"
                            fill="#22A57A"
                          />
                        </svg>
                      </span>{" "}
                      {masterData?.lr_status[selectLrData?.lr_status]
                        ? masterData?.lr_status[selectLrData?.lr_status]
                        : ""}{" "}
                    </p>
                  </div>
                </div>
              ) : <div className="_lrl_otrBx selectedBxs" onClick={(e) => setShowSelectLr(true)}>
                <div className=" m-5 newCls_dlex">
                  <div className="clorl_rebls">
                    + Select LR
                  </div>
                </div>
              </div>}
              {formError?.lr_id && (
                <span className="input_drop_error mt-0">
                  {formError?.lr_id}
                </span>
              )}


              <div className="_clPay_flex">
                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label="Payment Receipt Date & Time"
                    startDate={form?.date}
                    setStartDate={(data) => {
                      handleOnChange("date", data);
                    }}
                    error={formError?.date}
                    focus={!!formError?.date}
                  />
                </div>
                <div className="singleDiv">
                  <CustomSelect
                    label={categoryLabel}
                    placeholder={categoryPlace}
                    options={categoryOptions}
                    onSelect={(data) =>
                      handleOnChange("expense_category", data.value)
                    }
                    value={selectedCategory || { label: "", value: "" }}
                    focus={!!formError?.expense_category}
                    error={formError?.expense_category}
                    isAddButton={hasLinkCharofAccountPermission?.canCreate ? true : false}
                    addButtonAction={addExpenseHandle}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Amount (₹)"
                    placeholder="Amount (₹)"
                    name="amount"
                    value={form.amount}
                    onChange={({ target: { name, value } }) => {
                      if (Number(value) <= billRaiseDetailsData?.invoice_summary?.balance) {
                        handleOnChange(name, value);
                      }
                    }}
                    maxLength={10}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.amount}
                    error={formError.amount}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="textarea"
                    label="Notes"
                    placeholder="Notes"
                    name="description"
                    maxLength="500"
                    onInput={utils.maxLengthCheck}
                    value={form?.description}
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    focus={!!formError?.description}
                    error={formError.description}
                  />
                </div>

                <div className="singleDiv">
                  <div className="_payMode_hed">
                    <h4>
                      Payment Mode
                    </h4>
                    {claimAccount?.map((i) => (
                      <button
                        className={`_baseSpan ${i?.value == form?.account_sub_category
                          ? ""
                          : "_bspDisable"
                          }`}
                        name="account_sub_category"
                        disabled={
                          form?.account_sub_category != 10 &&
                          accountLoading
                        }
                        value={i?.value}
                        onClick={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                        }}
                      >
                        {i?.label}
                      </button>
                    ))}
                    {/* <button className="_baseSpan " >Cash</button>
                        <button className="_baseSpan _bspDisable" >Bank Transfer</button> */}
                    {/* <button className="_baseSpan _bspDisable">Balance</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="_balSuccess">
            <p>Balance</p>

            <p>
              ₹ {billRaiseDetailsData?.invoice_summary?.balance ? billRaiseDetailsData?.invoice_summary?.balance.toFixed(2) : 0}
            </p>
          </div>
          <div className="offcanvas-footer">
            <LoaderButton
              onClick={() => onSubmitClaim(0)}
              isLoading={isLoadding}
              isLoadingText="Processing..."
              className="_submitOn_modal"
              disabled={isLoadding}
            >
              Pay Party
            </LoaderButton>
          </div>
        </>
      </div>
      <div className={isOpen ? "offBack_drop" : ""}></div>

      {isOpenFuelModal && <AddEditModal
        {...openZoneModal}
      />}

      {showSelectLr &&
        <SelectLrForInvoiceDetailsModal {...selectLrModalProps} />
      }
    </div>
  );
};

export default ClaimInvoiceDetails;
